<!-- Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and -->
<!-- matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, -->
<!-- including without limitation, material generated from the software programs which are displayed on the screen such -->
<!-- as icons, screen display looks, etc. -->

<div>
  <section
    class="popover-button-container"
    [ngClass]="{ 'pad-top-label': padTopLabel }">
    @if (selectionType !== SettingType.MultiSelect) {
      <div>
        @if (label && showLabelOnTop) {
          <span [xdaTranslate]="label" class="top-label"></span>
        }
        @if (browserType < 3) {
          <button
            type="button"
            class="xrx-btn btn-secondary btn medium icon-button"
            (tap)="displayPopover($event)">
            @if (name && showIcon) {
              <span
                class="xrx-icon-sm"
                [ngClass]="
                  name === 'language' ? 'language' : param.icon
                "></span>
            }
            @if (label && showLabel && !showLabelOnTop) {
              <span [xdaTranslate]="label" class="bottom-label"></span>
            }
            @if (selectedValue) {
              <span
                [class.left]="valuePosition === 'left'"
                [ngClass]="{ 'left-normal': showLabelOnTop }"
                [xdaTranslate]="selectedValue[key]"></span>
            }
            @if (!selectedValue) {
              <span class="left-normal" [xdaTranslate]="inlineLabel"></span>
            }
          </button>
        }
        @if (browserType >= 3) {
          <button
            type="button"
            class="xrx-btn btn-secondary btn medium icon-button"
            (click)="displayPopover($event)">
            @if (name && showIcon) {
              <span
                class="xrx-icon-sm"
                [ngClass]="
                  name === 'language' ? 'language' : param.icon
                "></span>
            }
            @if (label && showLabel && !showLabelOnTop) {
              <span [xdaTranslate]="label" class="bottom-label"></span>
            }
            @if (selectedValue) {
              <span
                [class.left]="valuePosition === 'left'"
                [ngClass]="{ 'left-normal': showLabelOnTop }"
                [xdaTranslate]="selectedValue[key]"></span>
            }
            @if (!selectedValue) {
              <span class="left-normal" [xdaTranslate]="inlineLabel"></span>
            }
          </button>
        }
      </div>
    }
    @if (selectionType === SettingType.MultiSelect) {
      <div>
        @if (label && showLabelOnTop) {
          <span [xdaTranslate]="label" class="top-label"></span>
        }
        @if (browserType < 3) {
          <button
            type="button"
            class="xrx-btn btn-secondary btn medium icon-button"
            (tap)="displayMultiSelect()">
            @if (name && showIcon) {
              <span
                class="xrx-icon-sm"
                [ngClass]="
                  name === 'language' ? 'language' : param.icon
                "></span>
            }
            @if (selectedItems) {
              <span class="left-normal">{{ selectedItems }}</span>
            }
            @if (!selectedItems) {
              <span
                class="left-none-selected"
                [xdaTranslate]="'SDE_TO_LANGUAGE'"></span>
            }
          </button>
        }
        @if (browserType >= 3) {
          <button
            type="button"
            class="xrx-btn btn-secondary btn medium icon-button"
            (click)="displayMultiSelect()">
            @if (name && showIcon) {
              <span
                class="xrx-icon-sm"
                [ngClass]="
                  name === 'language' ? 'language' : param.icon
                "></span>
            }
            @if (selectedItems) {
              <span class="left-normal">{{ selectedItems }}</span>
            }
            @if (!selectedItems) {
              <span
                class="left-normal"
                [xdaTranslate]="'SDE_TO_LANGUAGE'"></span>
            }
          </button>
        }
      </div>
    }
  </section>
</div>
@if (isErrorState()) {
  <div class="invalid-options">
    @if (required && !error) {
      <label [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></label>
    }
    @if (error) {
      <label [xdaTranslate]="error"></label>
    }
  </div>
}

@if (showPopover) {
  <div #popover class="popover">
    <div class="popover-body" #contents>
      @if (selectionType !== SettingType.SelectWithGroup) {
        <ul>
          @for (option of list; track option) {
            <li>
              <button
                type="button"
                class="xrx-btn btn-secondary btn medium"
                [ngClass]="{
                  'icon-button': option.icon && option.glyph === undefined,
                  'glyph-btn': option.glyph,
                  selected:
                    selectedValue &&
                    selectedValue[key] === option[key] &&
                    selectedValue[property] === option[property],
                }"
                (click)="setValue(option)">
                @if (option.icon) {
                  <span class="xrx-icon-sm {{ option.icon }}"></span>
                }
                <span [xdaTranslate]="option[key]"></span>
                @if (option.glyph) {
                  <span class="glyph {{ option.glyph }}"></span>
                }
              </button>
            </li>
          }
        </ul>
      }
      @if (selectionType === SettingType.SelectWithGroup) {
        <ul>
          @for (group of list; track group; let isLast = $last) {
            <li class="group" [ngClass]="{ 'group-with-title': group.title }">
              @if (group.title) {
                <span class="group-title" [xdaTranslate]="group.title"></span>
              }
              <ul>
                @for (option of group.options; track option) {
                  <li>
                    <button
                      type="button"
                      class="xrx-btn btn-secondary btn medium"
                      [ngClass]="{
                        'icon-button':
                          option.icon && option.glyph === undefined,
                        'glyph-btn': option.glyph,
                        selected:
                          selectedValue &&
                          selectedValue[key] === option[key] &&
                          selectedValue[property] === option[property],
                      }"
                      (click)="setValue(option)">
                      @if (option.icon) {
                        <span class="xrx-icon-sm {{ option.icon }}"></span>
                      }
                      <span [xdaTranslate]="option[key]"></span>
                      @if (option.glyph) {
                        <span class="glyph {{ option.glyph }}"></span>
                      }
                    </button>
                  </li>
                }
              </ul>
            </li>
          }
        </ul>
      }
    </div>
    <span class="popup-top-shadow"></span>
    <span class="popup-bottom-shadow"></span>
  </div>
}

@if (showPopover) {
  <div #arrow class="arrow">
    <div style="height: 25px"></div>
    <div style="height: 23px; margin-top: 1px"></div>
    <div style="height: 21px; margin-top: 2px"></div>
    <div style="height: 19px; margin-top: 3px"></div>
    <div style="height: 17px; margin-top: 4px"></div>
    <div style="height: 15px; margin-top: 5px"></div>
    <div style="height: 13px; margin-top: 6px"></div>
    <div style="height: 11px; margin-top: 7px"></div>
    <div style="height: 9px; margin-top: 8px"></div>
    <div style="height: 7px; margin-top: 9px"></div>
    <div style="height: 5px; margin-top: 10px"></div>
    <div style="height: 3px; margin-top: 11px"></div>
    <div style="height: 1px; margin-top: 12px"></div>
  </div>
}
